import type { LoginBodyOverride } from "@Components/Login/bodyOverride";

import SiteLoginBodyBridge from "./SiteLoginBodyBridge";

/** Applied to the modal container on phones so sheet chrome is active before LoginBody mounts. */
export const HOME_V2_LOGIN_SHEET_CLASS = "homeV2LoginSheet";

/** Desktop centred card chrome for the Wander-style login modal. */
export const HOME_V2_LOGIN_DESKTOP_CLASS = "homeV2LoginDesktop";

const homeV2MobileModalParams = {
  size: "",
  className: HOME_V2_LOGIN_SHEET_CLASS,
  animation: "opacity",
} as const;

const homeV2DesktopModalParams = {
  className: HOME_V2_LOGIN_DESKTOP_CLASS,
} as const;

/** Shared HomeV3 login body + modal chrome (global and site-header routes). */
export const buildSiteLoginBodyOverride = (title: string): NonNullable<LoginBodyOverride> => ({
  Body: SiteLoginBodyBridge,
  title,
  mobileModalParams: { ...homeV2MobileModalParams },
  desktopModalParams: { ...homeV2DesktopModalParams },
});
